import { difference, without } from "lodash";
import create from "zustand";

type SelectionStore<T extends { id: number }> = {
  selection: T["id"][];
  reset: () => void;
  set: (selection: T["id"][]) => void;
  add: (id: T["id"]) => void;
  remove: (id: T["id"]) => void;
  removeMany: (ids: T["id"][]) => void;
};

export const createSelectionStore = <T extends { id: number }>() =>
  create<SelectionStore<T>>()((_set) => ({
    selection: [],
    reset: () => _set(() => ({ selection: [] })),
    set: (selection) => _set(() => ({ selection })),
    add: (id) => _set((state) => ({ selection: [...state.selection, id] })),
    remove: (id) =>
      _set((state) => ({ selection: without(state.selection, id) })),
    removeMany: (ids) =>
      _set((state) => ({ selection: difference(state.selection, ids) })),
  }));
